import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Form,
  Input,
  Button,
  Select,
  Modal,
  Row,
  Col,
  Typography,
  Divider,
  InputNumber,
} from 'antd';
import { ExclamationCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

import {
  DevicesActions, ClientsActions, ContractActions, TagsActions,
} from '../../../actions';
import EditableTagGroup from './components/tags';
import { Container } from './styles';

const DeviceRegister = () => {
  const { Option } = Select;
  const { confirm } = Modal;
  const { Title } = Typography;
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { createDevice } = useSelector((state) => state.DevicesReducer);
  const { clientsList, loadMoreClients } = useSelector((state) => state.ClientsReducer);
  const { contractsList, loadMore } = useSelector((state) => state.ContractsReducer);
  const { tagsList } = useSelector((state) => state.TagsReducer);

  const [listOfTags, setListOfTags] = useState([]);
  const [initialTags, setInitialTags] = useState([]);
  const [activeABP, setAcitveABP] = useState('OTAA');
  const [encryptNS, setEncrypNS] = useState('APP');
  const [clientContracts, setClientContacts] = useState([]);

  // Função para modificação no estado de Ativação do dispositivo
  const activationChange = (values) => {
    setAcitveABP(values);
  };

  // Função para setar a criptografia do dispositivo
  const encryptionChange = (values) => {
    setEncrypNS(values);
  };

  function handleUpdateTags(tags) {
    setListOfTags(tags);
  }

  function findClientContractById(client_id) {
    const clientContract = contractsList.filter(
      (contract) => client_id === contract.client_id,
    );

    const clientsTags = tagsList.filter((tag) => client_id === tag.client_id)
      .map((tag) => tag.name);
    setInitialTags(clientsTags);
    setListOfTags(clientsTags);
    setClientContacts(clientContract);
  }

  // Cadastro de dispositivos
  async function onFinish(values) {
    createDevice.dev_eui = values.dev_eui;
    createDevice.tags = listOfTags || null;
    createDevice.activation = values.activation;
    createDevice.nwkskey = values.nwkskey || null;
    createDevice.dev_addr = values.dev_addr || null;
    createDevice.app_eui = values.app_eui;
    createDevice.app_key = values.app_key || null;
    createDevice.counters_size = values.counters_size;
    createDevice.dev_class = values.dev_class;
    createDevice.encryption = values.encryption;
    createDevice.appskey = values.appskey || null;
    createDevice.rx1.delay = values.delay || 1;
    createDevice.band = values.band || 'LA915-928A';
    createDevice.contract_id = values.contract_id;

    confirm({
      title: 'Confirma o cadastro do dispositivo ?',
      icon: <ExclamationCircleOutlined />,
      content: '',

      onOk() {
        dispatch(DevicesActions.async_add_device(createDevice));
      },
    });
  }

  useEffect(() => {
    if (clientsList.length < 1) {
      dispatch(ClientsActions.async_get_clients(100, 0));
      dispatch(ClientsActions.enable_load_more_clients(false));
    }

    if (loadMore) {
      dispatch(ContractActions.async_get_all_contracts(100, 0));
      dispatch(ContractActions.enable_load_more(false));
    }

    if (tagsList.length < 1) {
      dispatch(TagsActions.async_get_all_tags(100, 0));
      dispatch(TagsActions.load_more_tags(false));
    }
  }, [listOfTags, clientsList,
    contractsList, loadMore, loadMoreClients, initialTags]);

  return (
    <div id="device-registry">
      <Container>
        <Title>Cadastro de Dispositivos</Title>

        <Divider />

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          size="large"
          style={{ textAlign: 'left', padding: 30, width: '100%' }}
        >
          <Form.Item
            label="Cliente"
            name="client_id"
            rule={[
              {
                required: false,
                message: 'Selecione um cliente',
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Selecione o cliente"
              optionFilterProp="children"
              onChange={(value) => findClientContractById(value)}
              filterOption={
                  (input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
            >
              {clientsList.map(
                (client) => (
                  <Option key={client.id} value={client.id}>
                    {client.company_name}
                  </Option>
                ),
              )}
            </Select>

          </Form.Item>

          <Form.Item
            label="Contrato"
            name="contract_id"
            tooltip={{
              title: 'Selecione um cliente para visualizar os contratos.',
              icon: <InfoCircleOutlined />,
            }}
            rules={[
              {
                required: false,
                message: 'Por favor selecione um contrato!',
              },
            ]}
          >
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Selecione o Contrato"
              optionFilterProp="children"
            >
              {clientContracts.map((contract) => (
                <Option key={contract.key} value={contract.id}>
                  {contract.name || `contrato_${contract.id}`}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Row gutter={16}>
            <Col>
              <Form.Item
                label="Device EUI"
                name="dev_eui"
                rules={[
                  {
                    required: true,
                    message: 'Por favor adicione o Device EUI!',
                  },
                ]}
              >
                <Input
                  style={{ width: 450 }}
                  placeholder="Device EUI"
                  maxLength="16"
                />
              </Form.Item>
            </Col>

            <Col>
              <h3>Tags</h3>
              <Form.Item
                name="tags"
                rules={[
                  {
                    required: false,
                    message: 'Por favor adicione ao menos uma tag!',
                    type: 'array',
                  },
                ]}
              >
                <EditableTagGroup
                  key={listOfTags}
                  newtags={handleUpdateTags}
                  mytags={listOfTags}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} justify="space-between">
            <Col>
              <Form.Item
                label="Modo de ativação"
                name="activation"
                rules={[
                  {
                    required: true,
                    message: 'Por favor selecione a ativação!',
                  },
                ]}
              >
                <Select
                  style={{ width: 450 }}
                  placeholder="Ativação"
                  onChange={activationChange}
                >
                  <Option key="ABP" value="ABP">ABP</Option>
                  <Option key="OTAA" value="OTAA">OTAA</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="NwsKey"
                name="nwkskey"
                tooltip={{
                  title: 'Network Session Key.',
                  icon: <InfoCircleOutlined />,
                }}
                rules={[
                  {
                    required: activeABP === 'ABP',
                    message: 'Por favor adicione o NwsKey!',
                  },
                ]}
              >
                <Input
                  style={{ width: 450 }}
                  placeholder="Nwskey"
                  disabled={activeABP === 'OTAA'}
                  maxLength="32"
                />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="Dev Address"
                name="dev_addr"
                rules={[
                  {
                    required: (activeABP === 'ABP'),
                    message: 'Por favor adicione o Device Address!',
                  },
                ]}
              >
                <Input
                  disabled={activeABP === 'OTAA'}
                  style={{ width: 450 }}
                  placeholder="Dev Address"
                  maxLength="8"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} justify="space-between">
            <Col>
              <Form.Item
                label="App EUI"
                name="app_eui"
                rules={[
                  {
                    required: true,
                    message: 'Por favor adicione o App EUI!',
                  },
                ]}
              >
                <Input
                  style={{ width: 450 }}
                  placeholder="App EUI"
                  maxLength="16"
                />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="Counter Size"
                name="counters_size"
                rules={[
                  {
                    required: true,
                    message: 'Por favor selecione o Counter Size!',
                  },
                ]}
              >
                <Select style={{ width: 450 }} placeholder="Counter">
                  <Option key="counter_size_4" value={4}>4</Option>
                  <Option key="counter_size_2" value={2}>2</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="Dev Class"
                name="dev_class"
                rules={[
                  {
                    required: true,
                    message: 'Por favor selecione o Dev Class!',
                  },
                ]}
              >
                <Select style={{ width: 450 }} placeholder="Dev">
                  <Option key="A" value="A">A</Option>
                  <Option key="C" value="C">C</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-between">
            <Col>
              <Form.Item
                label="Encriptação"
                name="encryption"
                rules={[
                  {
                    required: true,
                    message: 'Por favor selecione o Encryption!',
                  },
                ]}
              >
                <Select
                  style={{ width: 450 }}
                  placeholder="Encryption"
                  onChange={encryptionChange}
                >
                  <Option key="APP" value="APP">APP</Option>
                  <Option key="NS" value="NS">NS</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="App Session KEY"
                name="appskey"
                rules={[
                  {
                    required: (encryptNS === 'NS' && activeABP === 'ABP'),
                    message: 'Por favor adicione o Apps Key!',
                  },
                ]}
              >
                <Input
                  style={{ width: 450 }}
                  placeholder="Apps KEY"
                  maxLength="32"
                  disabled={!(encryptNS === 'NS' && activeABP === 'ABP')}
                  // ABP && NS
                />
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="App Key"
                name="app_key"
                rules={[
                  {
                    required: false,
                    message: 'Por favor adicione o App Key!',
                  },
                ]}
              >
                <Input
                  style={{ width: 450 }}
                  placeholder="App KEY"
                  maxLength="32"
                  disabled={!(encryptNS === 'NS' && activeABP === 'OTAA')}
                  // habilitado em OTAA && NS
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={160}>
            <Col>
              <Form.Item
                label="Banda"
                name="band"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select style={{ width: 450 }}>
                  <Option value="LA915-928A">LA915-928A</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item
                label="Rx1"
                name="delay"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <InputNumber min={0} max={100000} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Cadastrar
            </Button>
          </Form.Item>
        </Form>

      </Container>
    </div>
  );
};

export default DeviceRegister;
